import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Model } from 'projects/core/src/include/model';
import { CustomField } from 'projects/core/src/include/structures';
import { CustomfieldsService } from 'projects/core/src/lib/customfields.service';

@Component({
  selector: 'app-customfieldssettingsdetail',
  templateUrl: './detail.component.html',
  styleUrl: './detail.component.css'
})
export class CustomfieldssettingsDetailComponent extends Model<CustomField> implements OnInit {
  
  @Input()
  table:string="";
  
  customfields:any[]=[];
  
  constructor(
    private customfieldservice: CustomfieldsService,
      private route1: ActivatedRoute,
      
      ) {
        super(route1,customfieldservice); 
        
        
    }


    ngOnInit (): void {
    
        this.title = 'Dettaglio Campo personalizzato';
        this.record=new CustomField();
        this.record.table=this.table;
        super.ngOnInit.apply(this, arguments); 

        this.customfieldservice.getCustomFields(this.table).subscribe((result)=>{
          this.customfields=result;
        })

        this.getItem();
    }
}
